const SELLER_CARTS_KEY = "seller-carts" as const;

/**
 * The segment that marks a shipping-options query inside the seller-cart key
 * space. Exported because `cache.ts` invalidates *around* it: shipping options
 * live under the seller-cart prefix (they belong to a cart) but change for
 * different reasons than the cart itself, so the blanket cart invalidation
 * skips them by testing this segment. Named here rather than re-typed there so
 * the two can't drift.
 */
export const SHIPPING_OPTIONS_SEGMENT = "shipping-options" as const;

/** Marks a cart line's variant-options query. Only this file builds it. */
const VARIANT_OPTIONS_SEGMENT = "variant-options" as const;

export const queryKeys = {
  /**
   * Query keys for the multi-seller cart architecture.
   * Each customer can have one active cart per seller.
   */
  sellerCarts: {
    /** All seller carts for the authenticated customer */
    all: [SELLER_CARTS_KEY] as const,

    /** Filtered seller carts by cart IDs */
    filtered: (cartIds: string[]) =>
      [SELLER_CARTS_KEY, "filtered", ...cartIds] as const,

    /** Single cart by ID */
    detail: (cartId: string) => [SELLER_CARTS_KEY, cartId] as const,

    /** Shipping options for a specific cart */
    shippingOptions: (cartId: string) =>
      [SELLER_CARTS_KEY, SHIPPING_OPTIONS_SEGMENT, cartId] as const,

    /**
     * The variants a cart line can be switched to. Under the seller-cart
     * prefix on purpose: which one is current depends on the line's contents,
     * so any cart change should mark an open picker's list stale.
     */
    variantOptions: (cartId: string, lineItemId: string) =>
      [SELLER_CARTS_KEY, VARIANT_OPTIONS_SEGMENT, cartId, lineItemId] as const
  }
};
